import React, { useCallback } from "react";
import OrgTable from "../../OrgSettings/CourierPartners/OrgTable";
import OrgRowDetails from "../OrgRowDetails";
import "./style.scss";

const Table = ({
  data,
  onOrgEdit = (org) => null,
  expandable = true
}) => {
  const rowRenderer = useCallback((org) => {
    const getFullUrl = (baseUrl) => {
      if (!baseUrl) return "#";
      const newUrl = baseUrl.trim();
      return newUrl.startsWith("http://") || newUrl.startsWith("https://")
        ? newUrl
        : `https://${newUrl}`;
    };

    return (
      <>
        <div>{org.name}</div>
        <div>
          <a
            href={getFullUrl(org.baseUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {org.baseUrl}
          </a>
        </div>      
        <div>
          {org.isActive === 1 ? "Active" : "Inactive"}
        </div>
        <div>
          {org.trackingIdConstraint}
        </div>
      </>
    );
  }, []);

  const rowDetailsRenderer = useCallback(
    (org) => {
      return (
          <OrgRowDetails
            org={org}
          />
      );
    },
    []
  );

  return (
    <OrgTable
      className="partner-org-table"
      headers={["PARTNER", "BASE URL", "STATUS", "CONSTRAINTS", null]}
      data={data}
      gridTemplateColumns="1fr 2fr 2fr 1fr"
      rowRenderer={rowRenderer}
      rowDetailsRenderer={rowDetailsRenderer}
      onOrgEdit={onOrgEdit}
      expandable={expandable}
    />
  );
};

export default Table;
